import { useEffect, useState } from "react";

const SUBMIT_URL = "https://readdy.ai/api/form/daglbqhtto0ceqqnhuj0";

type Status = "idle" | "success" | "error";

export default function Footer() {
  const [show, setShow] = useState(false);
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honey = String(data.get("website_alt") || "").trim();

    if (honey) {
      setStatus("success");
      setMessage("订阅成功，欢迎加入最快吃瓜速报！");
      form.reset();
      return;
    }

    setLoading(true);
    setStatus("idle");
    setMessage("");
    const payload = new URLSearchParams();
    data.forEach((v, k) => {
      if (k === "website_alt") return;
      payload.append(k, String(v));
    });

    try {
      const res = await fetch(SUBMIT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: any = null;
      try {
        parsed = responseText ? JSON.parse(responseText) : null;
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || "";
      const isSpam = /spam/i.test(serverMsg);

      if (res.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功，欢迎加入最快吃瓜速报！");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <footer className="border-t border-background-200 bg-secondary-200/70">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 md:px-6 md:py-16 md:grid-cols-12">
          <div className="md:col-span-4">
            <a href="#hero" className="flex items-center gap-2 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">最快吃瓜</span>
            </a>
            <p className="mt-4 max-w-xs text-sm leading-6 text-foreground-600">
              刚刚发生、现场直击、今日新瓜，还原事件现场细节，不遗漏任何关键信息，
              吃瓜群众必备的速报指南。
            </p>
            <p className="mt-5 inline-flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-mail-line" />
              <a href="mailto:support@zuikuaichigua.cn" className="hover:text-primary-700 cursor-pointer">
                support@zuikuaichigua.cn
              </a>
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs font-bold uppercase tracking-widest text-foreground-500">内容栏目</p>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              {[
                ["#latest", "刚刚发生"],
                ["#live", "现场直击"],
                ["#top", "今日新瓜"],
                ["#cat", "吃瓜分类"],
              ].map(([href, label]) => (
                <li key={label}>
                  <a href={href} className="transition-colors hover:text-primary-700 cursor-pointer">{label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs font-bold uppercase tracking-widest text-foreground-500">了解我们</p>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              {[
                ["#about", "关于本站"],
                ["#faq", "常见问题"],
                ["#about", "内容原则"],
                ["#faq", "投稿线索"],
              ].map(([href, label]) => (
                <li key={label}>
                  <a href={href} className="transition-colors hover:text-primary-700 cursor-pointer">{label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-bold uppercase tracking-widest text-foreground-500">订阅追瓜提醒</p>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              留下邮箱，每天两班推送为你送上当日的今日新瓜与最新进展摘要，随时可退订。
            </p>
            <form
              id="newsletter-form"
              data-readdy-form="true"
              className="mt-4"
              onSubmit={handleSubmit}
              noValidate
            >
              <div className="flex flex-col gap-2 sm:flex-row">
                <label htmlFor="footer-email" className="sr-only">邮箱地址</label>
                <input
                  id="footer-email"
                  name="email"
                  type="email"
                  required
                  autoComplete="off"
                  placeholder="输入你的邮箱地址"
                  className="w-full flex-1 rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
                />
                <button
                  type="submit"
                  disabled={loading}
                  className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 disabled:opacity-60 cursor-pointer"
                >
                  {loading ? "提交中…" : "订阅速报"}
                </button>
              </div>
              {/* 反垃圾隐藏字段 */}
              <input
                className="newsletter-hp-field"
                name="website_alt"
                type="text"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              {status === "success" && (
                <p className="mt-3 flex items-center gap-1.5 text-sm font-medium text-primary-700">
                  <i className="ri-checkbox-circle-fill" /> {message}
                </p>
              )}
              {status === "error" && (
                <p className="mt-3 flex items-start gap-1.5 text-sm font-medium text-primary-600">
                  <i className="ri-alert-line mt-0.5" /> {message}
                </p>
              )}
            </form>
            <p className="mt-3 text-xs text-foreground-500">
              订阅即表示同意接收速报邮件。我们尊重你的收件箱，绝不骚扰。
            </p>
          </div>
        </div>

        <div className="border-t border-background-300/70">
          <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
            <p>© {new Date().getFullYear()} 最快吃瓜 · 全网热点速报站。本站内容均源自公开信息整理，仅供参考。</p>
            <div className="flex flex-wrap items-center gap-4">
              <a href="#about" className="whitespace-nowrap hover:text-primary-700 cursor-pointer">免责声明</a>
              <a href="#faq" className="whitespace-nowrap hover:text-primary-700 cursor-pointer">隐私说明</a>
              <span className="whitespace-nowrap">刚刚发生 · 现场直击 · 今日新瓜</span>
            </div>
          </div>
        </div>
      </footer>

      {show && (
        <button
          type="button"
          aria-label="返回顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-transform hover:-translate-y-1 hover:bg-primary-600 cursor-pointer"
        >
          <i className="ri-arrow-up-line text-lg" />
        </button>
      )}
    </>
  );
}